<template>
  <div class="my-table aduitPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('aduit.txt1')}}</span>
        <span>{{$t('aduit.txt2')}} / {{$t('aduit.txt3')}}</span>
      </div>
      <div class="flexEnd">
        <div class="handleBoxSelect">
          <el-select v-model="queryInfo.me" :placeholder="$t('aduit.txt4')" @change="getLoadData">
            <el-option
              v-for="(item,index) in navs"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="handleBoxSeach flexCenter">
          <el-input
            :placeholder="$t('aduit.txt5')"
             v-model="fromData.cmptName" @keypress.native.enter="loadData">
            <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </el-input>
          <div class="searchBtn">{{$t('aduit.txt6')}}</div>
        </div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="noBg">
      <el-table :data="dataList" v-loading="loading" :default-sort = "{prop: 'projName', order: 'descending'}" :row-class-name="tableRowClassName">
          <el-table-column
            :label="$t('diskMain.txt1')"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column :label="$t('aduit.txt7')">
            <template slot-scope="scope">
              <span>{{scope.row.applyUser.userName || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('aduit.txt8')" >
            <template slot-scope="scope">
              <span>{{scope.row.path}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('aduit.txt9')" >
                <!-- <span  v-if="(scope.row.status == 1 || scope.row.status == 4) && !scope.row.isAdmin" @click="handleDownload(scope.row.id)" class="handleBtn" type="text">申请下载</span> -->
              <span>{{$t('aduit.txt10')}}</span>
          </el-table-column>
          <el-table-column :label="$t('aduit.txt11')">
            <template slot-scope="scope">
              <span>{{formatDate(scope.row.createTime)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('aduit.txt12')">
            <template slot-scope="scope">
              <div class="txtGray">
                <span v-if="scope.row.status == 0">{{$t('aduit.txt13')}}</span>
                <span class="successTxt" v-if="scope.row.status == 1">{{$t('aduit.txt14')}}</span>
                <span class="warningTxt" v-if="scope.row.status == 2">{{$t('aduit.txt15')}}</span>
                <!-- <span v-if="scope.row.status == 4 && scope.row.isAdmin">已下载</span> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column  :label="$t('aduit.txt16')" width="130px">
            <template slot-scope="scope">
              <div>
                <el-button class="handleBtn" type="text" v-if="scope.row.status == 0 && scope.row.isAdmin" @click="handleAgree(scope.row.id, 1)">{{$t('aduit.txt17')}}</el-button>
                <el-button class="handleBtn" type="text" v-if="scope.row.status == 0 && scope.row.isAdmin"  @click="handleAgree(scope.row.id, 2)">{{$t('aduit.txt18')}}</el-button>
                <el-button class="handleBtn" type="text" v-if="scope.row.status == 1"  @click="handleDownload(scope.row.id)">{{$t('aduit.txt19')}}</el-button>
              </div>
            </template>
          </el-table-column>
      </el-table> 
    </el-card>
    <pagination style="text-align: right;" :total="total" :page.sync="queryInfo.pageNum"
			:limit.sync="queryInfo.pageSize" @pagination="loadData" />
    <!-- <div class="table-footer tablePagination" >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>    -->
  </div>
</template>

<script>
  import { formatDate } from "@/plugins/date.js";
  import pagination from "../../common/pagination";
  import { downloadFile } from '@/utils/fileRequest';  
  import qs from 'qs';
  export default {
    components: {
				pagination
			},
    data() {
      return {
        isIndeterminate: true,
        time:'',
        fromData:{},//分享参数
        options:[],//测试数据
        editRoleForm:{},//修改角色参数
        addUserForm:{},//添加用户参数
        editPasswordForm:{},//修改密码参数
        //用于获取数据列表
        queryInfo: {
          pageNum:0,
          pageSize: 10,
          projName:'',
          me: '3',
        },
        navs: [
            {label: this.$t('aduit.txt20'), value: '3'},
            {label: this.$t('aduit.txt21'), value: '1'},
            {label: this.$t('aduit.txt22'), value: '2'},
        ],
        navsIndex: 0,
        dataList: [],
        loading: false,
        total: 0,
        uploading: false, //正在上传
        progress: 0, //上传进度条
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      getLoadData(){
        this.queryInfo.pageNum = 0;
        this.loadData();
      },
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd hh:mm:ss");
      },
      handleNav(index) {
          this.navsIndex = index
          this.queryInfo.me = this.navs[index].value
          this.loadData()
      },
      // 数据加载
      async loadData(){
            this.loading = true;
            const { data: res } = await this.$http.post("/download/apply/list?" + qs.stringify(this.queryInfo));
            this.loading = false;
            if(!res.success){
            return this.$message.error(res.message);
            }
            res.result.data && res.result.data.forEach(item => {
                item.isAdmin = item.project.admin.id === localStorage.roleId
                item.paths = JSON.parse(item.path)
            })
            
            this.dataList = res.result.data;
            this.total = res.result.total;
      },
      async handleAgree(id, status) {
          const data = {
              status,
              id
          }
          const { data: res } = await this.$http.post("/download/apply/agree?" + qs.stringify(data));
            if(!res.success) {
                return this.$message.warning(res.message)
            }
            this.$message.success(this.$t('diskMain.txt23'))
            this.loadData()
      },
      async handleDownload(id) {
          // try{
          //     const res = await downloadFile('post', '/download/apply/download?id=' + id)
          //     this.loadData()
          // }
          // catch(e) {
          //     console.log(e)
          // }

          if(this.uploading){
              console.log("任务进行中,请稍后!")
              this.$message({
                  message: '任务进行中,请稍后!',
                  type: 'warning'
              });
              return;
          }
          const notification = this.$notify({
              //title: '上传进度',
              message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
              position: 'bottom-right',
              offset: 100,
              showClose: false, //不显示关闭按钮
              dangerouslyUseHTMLString: true, // 关键：允许解析HTML
              duration: 0, // 关键：设置为0表示不自动关闭
              customClass: 'custom-upload-notify' // 添加自定义类名
          });                          
      
          //隐藏进度条，只显示中文即可
          var uploadProgress = document.getElementById('uploadProgress');
          uploadProgress.style.display = 'none';

          var uploadProgressText = document.getElementById('uploadProgressText');
          uploadProgressText.innerHTML = "正在打包中,请稍等";
                            

          this.uploading = true;
          this.progress = 0;
          try {
              const response = await this.$http.post('/download/apply/download?id=' + id);
              console.log('获取url', response.data);
              if(!response.data.success){
                this.$message.warning(response.data.message)
                return;
              }

              const zip = response.data.result;
              console.log(zip)
              var url = this.$http.defaults.baseURL + "/project/download?path=" + zip;
              console.log(url)

              //创建隐藏的<a>标签
              const link = document.createElement("a");
              link.href = url;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              
          } catch (error) {
              console.error('获取url失败:', error);
              //alert('上传失败，请检查控制台');
          } finally {
              this.uploading = false;
              // e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
              //稍后关闭进度条
              setTimeout(() => {
                notification.close() //关闭进度条
              }, 800);                            
          }           
      },
      // 修改角色
      handleEditRole(){
        this.dialogFormEditRoleVisible = true;
      },
      // 修改密码
      handleEditPassword(){
        this.dialogFormEditPasswordVisible = true;
      },
      tableRowClassName({row, rowIndex}) {
        if (row.installStatus == 2) {
          return 'warning-row';
        } else if (row.installStatus == 1) {
          return 'success-row';
        }
        return '';
      },
      // 删除
      handleDelete(){
        this.$confirm('<p class="color666 fz14">'+this.$t('diskMain.txt24')+'</p><p class="color999 fz14">'+this.$t('diskMain.txt25')+'</p>', this.$t('diskMain.txt26'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('diskMain.txt27'),
          cancelButtonText: this.$t('diskMain.txt28'),
          type: 'warning',
          center: true
        }).then(() => {
          this.$message({
            type: 'info',
            message: this.$t('diskMain.txt29')
          }); 
        }).catch(() => {
          this.$message({
            type: 'success',
            message: this.$t('diskMain.txt30')
          });         
        });
      },
      // 冻结
      handleFrozen(){
        this.$confirm('<p class="color666 fz14">'+this.$t('diskMain.txt31')+'</p><p class="color999 fz14">'+this.$t('diskMain.txt32')+'</p>', this.$t('diskMain.txt33'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('diskMain.txt27'),
          cancelButtonText: this.$t('diskMain.txt28'),
          type: 'warning',
          center: true
        }).then(() => {
          this.$message({
            type: 'info',
            message: this.$t('diskMain.txt34')
          }); 
        }).catch(() => {
          this.$message({
            type: 'success',
            message: this.$t('diskMain.txt35')
          });         
        });
      },
      // 搜索
      handleSearch(){
        this.queryInfo.pageNum = 0;
        this.queryInfo.pageSize = 10;
        this.loadData();
      },
      // 编辑/详情
      handleDetail(row,type){
        this.$router.push({path: "/sceneRecordDetail",query: {type: type,id: row.id}});
      },
      // 页面切换
      handleCurrentChange(pageNum) {
        this.queryInfo.pageNum = pageNum;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.queryInfo.pageSize = pageSize;
        this.loadData();
      },
    },
  };
</script>

<style lang="less" scoped>
  .aduitPage{
    /deep/ .el-button+.el-button{
      margin-left: 0;
    }
    .el-table .warning-row {
      background: #F3F8F5;
    }
  
    .el-table .success-row {
      background: #F8F3F3;
    }
    .warning-row td:first-of-type{
      border-left: 3px solid #1B7C3A;
      border-radius: 3px 0px 0px 3px;
    }
    .success-row td:first-of-type{
      border-left: 3px solid #7C1B1B;
      border-radius: 3px 0px 0px 3px;
    }
    .el-table .successTxt{
      color: #1B7C3A;
    }
    .el-table .warningTxt{
      color: #7C1B1B;
    }
    .searchBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      .btnC{
        padding:0.6rem 2.6rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-form-item:first-of-type,/deep/ .el-form-item:last-of-type{
        margin-bottom: 0;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
  }
  .handleBtn{
      padding: 0;
  }
</style>
